/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeviceTypeCertificateEtcResponse
 */
export interface DeviceTypeCertificateEtcResponse {
    /**
     * 
     * @type {string}
     * @memberof DeviceTypeCertificateEtcResponse
     */
    commonName: string;
}

export function DeviceTypeCertificateEtcResponseFromJSON(json: any): DeviceTypeCertificateEtcResponse {
    return DeviceTypeCertificateEtcResponseFromJSONTyped(json, false);
}

export function DeviceTypeCertificateEtcResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeviceTypeCertificateEtcResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'commonName': json['commonName'],
    };
}

export function DeviceTypeCertificateEtcResponseToJSON(value?: DeviceTypeCertificateEtcResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'commonName': value.commonName,
    };
}

